enum colors {
    ligthgray = 'ligthgray',
    white = 'white',
    green = 'green',
    darkgray = 'darkgray',
    red = "red",
    transparent = "transparent"
}
  
  export default colors;